module.exports = __webpack_public_path__ + "img/Entertainment_Recall_3_Set.8037b64a.png";